// Parts checklist for the Game Designer Kit build.
// 10 parts total. Labels/images provided by the user.

export const parts = [
  { id: "pcb", label: "PCB Board (with battery and battery holder)", img: "/parts/pcb.png" },
  { id: "microbit", label: "Micro:bit", img: "/parts/microbit.png" },
  { id: "top-panel", label: "Top Panel", img: "/parts/top-panel.png" },
  { id: "bottom-panel", label: "Bottom Panel", img: "/parts/bottom-panel.png" },
  { id: "yellow-buttons", label: "Yellow Buttons x 4", img: "/parts/yellow-buttons.png" },
  { id: "red-buttons", label: "Red Buttons x 3", img: "/parts/red-buttons.png" },
  { id: "big-spacer", label: "Big Spacer", img: "/parts/big-spacer.png" },
  { id: "small-spacer", label: "Small Spacer", img: "/parts/small-spacer.png" },
  { id: "screw", label: "Screw", img: "/parts/screw.png" },
  { id: "holder-tag", label: "Holder Tag", img: "/parts/holder-tag.png" },
  { id: "screwdriver", label: "Screwdriver", img: "/parts/screwdriver.png" },
];
